/**
 * @generated SignedSource<<4e786c2c3a2addcdb08c405f971bdcec>>
 * @relayHash 760113b4d7a9d899532af7823cd6a3cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68

import type { ConcreteRequest } from 'relay-runtime';
export type HelpCenterNavigationBarBorderType = "ALL_BORDER" | "BOTTOM_BORDER" | "NO_BORDER" | "%future added value";
export type HelpCenterNavigationBarPositionType = "FIXED" | "FLOATING" | "%future added value";
export type HelpCenterProductEntityType = "COMMON_REQUEST_TYPES" | "COMMON_REQUEST_TYPES_KOSH" | "JSM_HELP_OBJECTS" | "KB_CATEGORIES" | "KNOWLEDGE_CARDS" | "PORTAL_GROUPS" | "%future added value";
export type HelpCenterUpdateInput = {
  helpCenterAri: string;
  helpCenterBranding?: HelpCenterBrandingInput | null;
  homePageLayout?: HelpCenterHomePageLayoutInput | null;
  name?: HelpCenterNameInput | null;
  productEntityImages?: ReadonlyArray<HelpCenterProductEntityImageInput> | null;
  slug?: string | null;
  virtualAgentEnabled?: boolean | null;
};
export type HelpCenterBrandingInput = {
  banner?: HelpCenterBannerInput | null;
  colors?: HelpCenterBrandingColorsInput | null;
  homePageTitle?: HelpCenterHomePageTitleInput | null;
  logo?: HelpCenterLogoInput | null;
  navigationBar?: HelpCenterNavigationBarInput | null;
  typography?: HelpCenterBrandingTypographyInput | null;
};
export type HelpCenterBannerInput = {
  filedId?: string | null;
  useDefaultBanner?: boolean | null;
};
export type HelpCenterBrandingColorsInput = {
  bannerTextColor?: string | null;
  primary?: string | null;
  secondaryColor?: string | null;
  topBarColor?: string | null;
  topBarTextColor?: string | null;
};
export type HelpCenterHomePageTitleInput = {
  default: string;
  translations?: ReadonlyArray<HelpCenterTranslationInput | null> | null;
};
export type HelpCenterTranslationInput = {
  locale: string;
  localeDisplayName?: string | null;
  value: string;
};
export type HelpCenterLogoInput = {
  fileId?: string | null;
};
export type HelpCenterNavigationBarInput = {
  backgroundColor?: string | null;
  borderColor?: string | null;
  borderType?: HelpCenterNavigationBarBorderType | null;
  cornerRadius?: number | null;
  padding?: boolean | null;
  positionType?: HelpCenterNavigationBarPositionType | null;
  textColor?: string | null;
};
export type HelpCenterBrandingTypographyInput = {
  bodyFont?: string | null;
  headingFont?: string | null;
};
export type HelpCenterHomePageLayoutInput = {
  layoutAdf?: string | null;
  metadata?: string | null;
};
export type HelpCenterNameInput = {
  default: string;
  translations?: ReadonlyArray<HelpCenterTranslationInput | null> | null;
};
export type HelpCenterProductEntityImageInput = {
  entityId: string;
  entityType: HelpCenterProductEntityType;
  fileId?: string | null;
  imageUrl?: string | null;
};
export type useHelpCenterUpdateMutation$variables = {
  cloudId: string;
  input: HelpCenterUpdateInput;
};
export type useHelpCenterUpdateMutation$data = {
  readonly helpCenter: {
    readonly updateHelpCenter: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null;
        } | null;
        readonly message: string | null;
      }> | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type useHelpCenterUpdateMutation = {
  response: useHelpCenterUpdateMutation$data;
  variables: useHelpCenterUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHelpCenterUpdateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterUpdatePayload",
            "kind": "LinkedField",
            "name": "updateHelpCenter",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHelpCenterUpdateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterUpdatePayload",
            "kind": "LinkedField",
            "name": "updateHelpCenter",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68",
    "metadata": {},
    "name": "useHelpCenterUpdateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "162638a77ba5d44dfe258f5e31598716";

export default node;
